import { render } from "./ClientsEmails.vue?vue&type=template&id=7af251bc"
import script from "./ClientsEmails.vue?vue&type=script&lang=js"
export * from "./ClientsEmails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__